var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "appraisal-modal-confirm",
        "data-cy": "appraisal-modal-confirm",
        "destroy-on-hide": false,
        "aria-role": "dialog",
        "aria-label": "Procesar Valorización",
        "has-modal-card": "",
        "trap-focus": "",
        "on-cancel": _vm.close,
        "aria-modal": "",
      },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      _c("div", { staticClass: "modal-card", staticStyle: { width: "auto" } }, [
        _c("header", { staticClass: "modal-card-body" }, [
          _c("div", { staticClass: "modal-card-title modal-title" }, [
            _vm._v(" Atención "),
          ]),
          _c("a", {
            staticClass: "close-modal delete",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ]),
        _c("section", { staticClass: "modal-card-body" }, [
          _c("p", [
            _vm._v(" Se procesará la valorización con los siguientes datos: "),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Comprador: ")]),
            _vm._v(
              " " +
                _vm._s(_vm.appraisal.investorName) +
                " (" +
                _vm._s(_vm.appraisal.investorId) +
                ") "
            ),
            _c("br"),
            _c("strong", [_vm._v("Tipo: ")]),
            _vm._v(_vm._s(_vm.appraisal.salesType) + " "),
            _c("br"),
            _c("strong", [_vm._v("Fecha de venta: ")]),
            _vm._v(_vm._s(_vm.appraisal.salesDate) + " "),
            _c("br"),
            _c("strong", [_vm._v("Operaciones: ")]),
            _vm._v(_vm._s(_vm.appraisal.totalOperations) + " "),
            _c("br"),
            _c("strong", [_vm._v("Total monto otorgado (UF): ")]),
            _vm._v(_vm._s(_vm.appraisal.totalAmountAwarded) + " "),
          ]),
          _c("p", { staticClass: "text-align-center" }, [
            _vm._v(" ¿Estás seguro que deseas continuar? "),
          ]),
          _c(
            "div",
            { staticClass: "buttons is-pulled-right" },
            [
              _c("b-button", {
                staticClass: "button is-button-secondary",
                attrs: {
                  id: "appraisal-modal-button-no",
                  "data-cy": "appraisal-modal-button-no",
                  label: "No",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
              _c("b-button", {
                staticClass: "button is-button-primary",
                attrs: {
                  id: "appraisal-modal-button-continuar",
                  "data-cy": "appraisal-modal-button-continuar",
                  label: "Continuar",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.confirm()
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }